export const NO_SHOW_TRACKER_HEADERS = [
  {
    key: 'campaign',
    label: 'Campaign',
    type: 'string',
    sort: true,
  },
  {
    key: 'date',
    label: 'Date',
    type: 'string',
    sort: true,
  },
  {
    key: 'week',
    label: 'Week',
    type: 'string',
    sort: true,
  },
  {
    key: 'time',
    label: 'Time',
    type: 'string',
    sort: true,
  },
  {
    key: 'city',
    label: 'City',
    type: 'string',
    sort: true,
  },
  {
    key: 'location',
    label: 'Location',
    type: 'string',
    sort: true,
  },
]
